import { Typography } from '@mui/material'
import _ from 'lodash'
import { GAMES_PAGE_REDESIGN_GROUP } from '@playback-rewards/shared-libraries'

import UnlockOffers from 'components/UnlockOffers'

import AllOffers from './AllOffers'
import ContinueRow from './ContinueRow'
import Featured, { selectFeaturedOffers } from './Featured'
import InProgress from './InProgress'

import './index.css'

const EmptyState = () => (
  <div className="gamesRedesignEmpty">
    <Typography variant="h2">You currently don&apos;t qualify for any Playback Offers</Typography>
    <Typography variant="h4">
      We&apos;re working with game publishers to get you the best offers available so be sure to
      check back later!
    </Typography>
  </div>
)

/**
 * The redesigned /games page.
 *
 * Featured, All offers and the empty state are the same in both variants. Only the offers
 * already in progress move: variant A keeps them inline at the top, variant B puts them in a
 * bar above the tabs.
 */
const GamesRedesign = ({ offers, observer, variant, experiment }) => {
  const activatedOffers = offers?.activatedRow || []
  const featuredRow = offers?.featuredRow || []
  const featuredOffers = selectFeaturedOffers(featuredRow)
  // Genre rows repeat an offer once per category; list it only once.
  const allOffers = _.uniqBy(
    (offers?.genresRows || []).flatMap((row) => row.offers || []),
    'id'
  )

  const isVariantB = variant === GAMES_PAGE_REDESIGN_GROUP.VARIANT_B
  const isEmpty = !activatedOffers.length && !featuredRow.length && !allOffers.length

  return (
    <div className={`gamesRedesign ${isVariantB ? 'variantB' : ''}`}>
      {isEmpty ? (
        <EmptyState />
      ) : (
        <>
          {!isVariantB && (
            <ContinueRow offers={activatedOffers} observer={observer} experiment={experiment} />
          )}
          <Featured offers={featuredOffers} observer={observer} experiment={experiment} />
        </>
      )}
      <div className="gamesRedesignSheet">
        {!isEmpty && <AllOffers offers={allOffers} observer={observer} experiment={experiment} />}
        <UnlockOffers />
      </div>
      {isVariantB && (
        <InProgress offers={activatedOffers} observer={observer} experiment={experiment} />
      )}
    </div>
  )
}

export default GamesRedesign
